import { MODALS } from 'src/models/ModalModel';
import EditContactForm from 'src/components/Forms/EditContactForm';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';

const EditContactModal = () => (
  <ModalBase
    name={MODALS.editContacts}
    size={MODALS_SIZE.small}
    form={FORM.get_contact}>
    <EditContactForm />
  </ModalBase>
);

export default EditContactModal;
//
